// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { cyberTestnet as _cyberTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the cyberTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 111557560
 * Chain Name: Cyber Testnet
 * Default Block Explorer: https://testnet.cyberscan.co
 * Default RPC URL: https://cyber-testnet.alt.technology
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { cyberTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: cyberTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const cyberTestnet = createCommon({
	..._cyberTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
